import { inject, Pipe, PipeTransform } from '@angular/core';
import { CountriesService } from "../services/countries.service";

@Pipe({
  name: 'country',
  standalone: true
})
export class CountryPipe implements PipeTransform {
  countriesService = inject(CountriesService);

  transform(countryCode: string | undefined | null): string {
    return CountryPipe.formatValue(countryCode) || '-';
  }

  static formatValue(countryCode: string | undefined | null): string {
    const countryCodeUpperCase = countryCode?.toUpperCase();

    if (!countryCodeUpperCase)
      return '';

    if (CountriesService.isAustralianState(countryCodeUpperCase)) {
      const countryArr = countryCodeUpperCase.split('-');
      return CountriesService.getCountryName(countryArr[1] ?? countryArr[0]) ?? countryCode ?? '-';
    }

    return CountriesService.getCountryName(countryCode!) || countryCode || '-';
  }

  static formatPlaceOfBirth(birthCity: string | undefined | null, birthCountry: string | undefined | null, defaultValue = ''): string {
    const country = CountryPipe.formatValue(birthCountry)
      || CountryPipe.formatValue('AU-' + birthCountry?.toUpperCase())
      || birthCountry;

    return [birthCity, country]
      .filter(Boolean)
      .join(', ') || defaultValue;
  }
}
